export default __webpack_public_path__ + "static/media/first-pdf-bg.7d84db80.png";